import clsx from 'clsx';
import selectStyles from '../Select.module.css';
import styles from '../MultiSelect.module.css';
import scrollbarStyles from '../../../styles/scrollbarThin.module.css';
import {
  CheckIcon,
  CheckboxCheckedIcon,
  CheckboxIndeterminateIcon,
  CheckboxUncheckedIcon,
} from '../../icons';
import { getFixedMenuWidthStyle, getMenuScrollLayout } from '../lib/multiSelectMenuMetrics';
import { getSelectMenuClassName, getSelectOptionClassName } from '../lib/selectClassNames';

export function MultiSelectMenu({
  listboxId,
  ariaLabel,
  menuPlacement,
  menuWidth,
  menuWidthPx,
  maxMenuRows,
  options,
  normalizedValues,
  highlightedIndex,
  setHighlightedIndex,
  toggleValue,
  showOptionCheckboxes,
  selectAllValue = null,
  allSelected = false,
  someSelected = false,
}) {
  const { needsMenuScroll, menuMaxHeightPx } = getMenuScrollLayout(maxMenuRows, options.length);
  const menuWidthStyle = getFixedMenuWidthStyle(menuWidthPx);
  const menuStyle = {
    ...(needsMenuScroll && menuMaxHeightPx != null ? { maxHeight: `${menuMaxHeightPx}px` } : {}),
    ...(menuWidthStyle ?? {}),
  };

  return (
    <ul
      id={listboxId}
      role="listbox"
      aria-label={ariaLabel}
      className={clsx(
        getSelectMenuClassName({ menuPlacement, menuWidth }),
        needsMenuScroll && scrollbarStyles.scrollbarThinY,
        needsMenuScroll && scrollbarStyles.overscrollContain,
      )}
      style={menuStyle}
    >
      {options.map((opt, index) => {
        const isSelectAllRow =
          selectAllValue != null && String(opt.value) === String(selectAllValue);
        const isSelected = isSelectAllRow
          ? allSelected
          : normalizedValues.includes(String(opt.value));
        const isIndeterminate = isSelectAllRow && !allSelected && someSelected;
        const isHighlighted = index === highlightedIndex;
        return (
          <li
            key={String(opt.value)}
            role="option"
            aria-selected={isSelected}
            className={clsx(
              getSelectOptionClassName({ isSelected, isHighlighted }),
              showOptionCheckboxes && styles.optionCheckbox,
            )}
            onMouseEnter={() => setHighlightedIndex(index)}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
              if (opt.disabled) return;
              toggleValue(opt.value);
            }}
          >
            {showOptionCheckboxes ? (
              <>
                <span className={clsx(styles.optionCheckboxCell)} aria-hidden>
                  {isSelected ? (
                    <span className={clsx(styles.optionCheckboxChecked)}>
                      <CheckboxCheckedIcon className={clsx(styles.optionCheckboxCheckedBg)} />
                      <CheckIcon className={clsx(styles.optionCheckboxCheckMark)} />
                    </span>
                  ) : isIndeterminate ? (
                    <span className={clsx(styles.optionCheckboxChecked)}>
                      <CheckboxCheckedIcon className={clsx(styles.optionCheckboxCheckedBg)} />
                      <CheckboxIndeterminateIcon className={clsx(styles.optionCheckboxCheckMark)} />
                    </span>
                  ) : (
                    <CheckboxUncheckedIcon className={clsx(styles.optionCheckboxUnchecked)} />
                  )}
                </span>
                <span className={clsx(selectStyles.optionLabel, styles.optionCheckboxLabel)}>
                  {opt.label}
                </span>
              </>
            ) : (
              <>
                <span className={clsx(selectStyles.optionLabel)}>{opt.label}</span>
                <span className={clsx(selectStyles.optionSpacer)} aria-hidden />
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
}
